import { Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { InteractionChannelAuditRequest } from '@genial/services/dist/models';
import { Utils, useBreakpointValue } from '@genial/utils';
import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { SendingChannelsController } from '../../../../../../../../hooks/useSendingChannels';
import { sessionState } from '../../../../../../../../store/session/atom';
import {
  ProveOrderOrigin,
  ProveOrderOriginProps,
} from '../../../../../../../NewApplication/Order/ProveOrderOrigin';

import { useChannelOptionsSelectionComponent } from './constants';

export interface TicketDetailsProps {
  sendingChannelsController: SendingChannelsController;
  setInteractionChannelAudit: React.Dispatch<
    React.SetStateAction<InteractionChannelAuditRequest | undefined | null>
  >;
  interactionChannelAudit: InteractionChannelAuditRequest | undefined | null;
  showSendingChannels: boolean;
  isSimplifiedApplicationFlagMatched: boolean;
  productTypeId: ProveOrderOriginProps['productTypeId'];
}

export const TicketDetails: React.FC<TicketDetailsProps> = ({
  setInteractionChannelAudit,
  sendingChannelsController,
  showSendingChannels,
  isSimplifiedApplicationFlagMatched,
  productTypeId,
}) => {
  const { userProfile } = useRecoilValue(sessionState);

  const isManager = !!(userProfile?.isGestor && userProfile?.idTipoParceiro !== 4);

  const isMobile = useBreakpointValue({ base: true, md: false });
  const ChannelOptionsSelectionComponent = useChannelOptionsSelectionComponent(
    sendingChannelsController,
    isManager
  );

  useEffect(() => {
    if (isManager) {
      setInteractionChannelAudit(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isManager]);

  if (isManager) {
    return (
      <Shadow level={1} borderRadius={BoxBorder.heavy} zIndex={10}>
        <VStack space="stack.xxxs" p="inset.sm" zIndex={10}>
          <Text variant="semibold" color={isMobile ? 'neutral.black' : 'brand.primary.principal'}>
            Conclua sua boleta
          </Text>
          <HStack w="full" alignItems="center" justifyContent="space-between">
            <Text>Data de envio</Text>
            <Text>{Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}</Text>
          </HStack>
        </VStack>
      </Shadow>
    );
  }

  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy} zIndex={10}>
      <VStack space="stack.xxxs" p="inset.sm" zIndex={10}>
        <Text variant="semibold" color={isMobile ? 'neutral.black' : 'brand.primary.principal'}>
          Conclua sua boleta
        </Text>
        <ProveOrderOrigin
          productTypeId={productTypeId}
          handleUpdateInteractionChannelAudit={setInteractionChannelAudit}
          hideDateTimeFields={isSimplifiedApplicationFlagMatched}
          forceOrderOriginRequired
          forceMobile
        />
        {showSendingChannels && ChannelOptionsSelectionComponent}
        <HStack w="full" alignItems="center" justifyContent="space-between">
          <Text>Data de envio</Text>
          <Text>{Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}</Text>
        </HStack>
      </VStack>
    </Shadow>
  );
};
